import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, map, mergeMap, catchError } from 'rxjs';
import * as UserInfoActions from '../_actions/user-info.actions';
import { UserInfoService } from '../_services/user-info.service';

@Injectable()
export class UserInfoEffects {
  submitUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInfoActions.submitUserInfo),
      mergeMap(({ formData }) =>
        this.userInfoService.submitUserInfo(formData).pipe(
          map(response => UserInfoActions.submitUserInfoSuccess({ response })),
          catchError(error => of(UserInfoActions.submitUserInfoFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userInfoService: UserInfoService
  ) {}
} 